/*
 * ******************************************************************
 * Copyright (c) 2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { VmwToastType } from "@vmw/ngx-components";
import { SeverityEnum } from "@api/generated/vcdr";

export class BannerInfo {
    public message: string;
    public type: string;

    constructor(message: string, severity: string) {
        this.message = message;
        this.type = this.getBannerType(severity);
    }

    private getBannerType(severity: string): string {
        switch (severity.toUpperCase()) {
            case SeverityEnum.CRITICAL:
            case SeverityEnum.ERROR:
                return "danger";
            case SeverityEnum.WARN:
            case "WARNING":
                return "warning";
            case SeverityEnum.INFO:
            default:
                return "info";
        }
    }
}

export class ToastInfo {
    public title: string;
    public message: string;
    public type: VmwToastType;

    constructor(title: string, message: string, severity: string) {
        this.title = title;
        this.message = message;
        this.type = this.getToastType(severity);
    }

    private getToastType(severity: string): VmwToastType {
        switch (severity.toUpperCase()) {
            case SeverityEnum.CRITICAL:
            case SeverityEnum.ERROR:
                return VmwToastType.FAILURE;
            case SeverityEnum.WARN:
            case "WARNING":
                return VmwToastType.WARN;
            case SeverityEnum.INFO:
            default:
                return VmwToastType.INFO;
        }
    }
}
